import Header from '../components/Header';
import Testimonials from '../components/Testimonials';
import Footer from '../components/Footer';

const TestimonialsPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main>
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
};

export default TestimonialsPage;